import { PlayerData } from "./PlayerData";

export class TargetData {
  constructor(group, players) {
    this.group = group;
    this.players = players;
  }

  static fromJson(json) {
    const players = (json.players || []).map((playerJson) =>
      PlayerData.fromJson(playerJson)
    );

    return new TargetData(json.group, players);
  }
}
